var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 7.36838,
    cy: 7.36838,
    r: 6.85434,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.02815,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.36842 1.02815C3.86679 1.02815 1.02815 3.86679 1.02815 7.36842C1.02815 10.8701 3.86679 13.7087 7.36842 13.7087C10.8701 13.7087 13.7087 10.8701 13.7087 7.36842C13.7087 3.86679 10.8701 1.02815 7.36842 1.02815ZM0 7.36842C0 3.29895 3.29895 0 7.36842 0C11.4379 0 14.7368 3.29895 14.7368 7.36842C14.7368 11.4379 11.4379 14.7368 7.36842 14.7368C3.29895 14.7368 0 11.4379 0 7.36842Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.67363L5.66667 10.4736L11 4.47363",
    stroke: "#20CB7F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.249b56c36b17dac1d8f829dd237084be.svg";
export { ForwardRef as ReactComponent };